export const LANDING_CONSTANTS = {
  demoDelayMs: 7500,
} as const;
